/**
 * UserTag Component
 * User tag with role-based color coding
 */

import React from "react";
import {
  Tag as ChakraTag, TagLabel, TagProps as ChakraTagProps, Avatar, HStack,
} from "@chakra-ui/react";
import { useColorModeValue } from "../hooks/useColorModeValue";
import {
  TextColorToken,
  SurfaceColorToken,
  BorderColorToken,
  PrimitiveColorToken,
} from "../foundation/Color";
import CDS from "../index";

export interface UserTagProps extends Omit<ChakraTagProps, "colorScheme" | "bg" | "color" | "borderColor"> {
  name: string;
  bgColor?: SurfaceColorToken | PrimitiveColorToken;
  textColor?: TextColorToken;
  borderColor?: BorderColorToken;
  avatarUrl?: string;
  showAvatar?: boolean;
}

function UserTagComponent({
  name,
  bgColor = CDS.Color.surface.secondary,
  textColor = CDS.Color.text.primary,
  borderColor = CDS.Color.border.secondary,
  avatarUrl,
  showAvatar = true,
  ...props
}: UserTagProps) {
  // Use color mode reactive colors
  const resolvedBgColor = useColorModeValue(bgColor);
  const resolvedTextColor = useColorModeValue(textColor);
  const resolvedBorderColor = useColorModeValue(borderColor);

  return (
    <ChakraTag
      size="md"
      variant="outline"
      border="1px solid"
      bg={resolvedBgColor}
      color={resolvedTextColor}
      borderColor={resolvedBorderColor}
      {...props}
    >
      <HStack spacing={2}>
        {showAvatar && (
          <Avatar
            size="xs"
            name={name}
            src={avatarUrl}
          />
        )}
        <TagLabel fontWeight="medium">
          {name}
        </TagLabel>
      </HStack>
    </ChakraTag>
  );
}

// Public API - just the component (no role tokens needed anymore)
export const UserTag = UserTagComponent;
